import type { EditPostModalProps } from "@circle-react/components/QuickPost/types";
import { getPostFormDefaults } from "@circle-react/components/QuickPostV3/data/getPostFormDefaults";
import type { EditablePostLookup } from "@circle-react/components/QuickPostV3/data/types";
import { useEditablePost } from "@circle-react/components/QuickPostV3/data/useEditablePost";
import { EditPostLoader } from "@circle-react/components/QuickPostV3/EditPostLoader";
import { QuickPostV3Form } from "@circle-react/components/QuickPostV3/Form";
import { CurrentPostContextProvider } from "@circle-react/contexts/currentPostContext";

interface EditPostWrapperProps {
  onForceClose: () => void;
  onPostChange?: EditPostModalProps["onPostChange"];
  onRequestClose: () => void;
  onSubmitSuccess?: EditPostModalProps["onSubmitSuccess"];
  post: EditablePostLookup;
  shouldSkipRedirectAfterSubmit?: EditPostModalProps["shouldSkipRedirectAfterSubmit"];
}

export const EditPostWrapper = ({
  post: stalePost,
  onForceClose,
  onPostChange,
  onRequestClose,
  onSubmitSuccess,
  shouldSkipRedirectAfterSubmit,
}: EditPostWrapperProps) => {
  const editablePost = useEditablePost(stalePost);

  if (editablePost.status !== "ready") {
    return <EditPostLoader />;
  }

  const { defaultValues, shouldShowTipTap } = getPostFormDefaults({
    post: editablePost.post,
    variant: "edit",
  });

  return (
    <CurrentPostContextProvider
      post={editablePost.post}
      onPostChange={onPostChange}
    >
      <QuickPostV3Form
        defaultValues={defaultValues}
        onForceClose={onForceClose}
        onRequestClose={onRequestClose}
        onSubmitSuccess={onSubmitSuccess}
        shouldSkipRedirectAfterSubmit={shouldSkipRedirectAfterSubmit}
        shouldShowTipTap={shouldShowTipTap}
        variant="edit"
      />
    </CurrentPostContextProvider>
  );
};
